/*
  EthicalAds client loader.
  - No cookies, no tracking — zero consent gate required.
  - Script loads once, globally, on app mount (if REACT_APP_ETHICALADS_ID is set).
  - Individual AdSlot components call `loadAd(el)` after mount so the client
    scans newly-added placements on route transitions.
  Docs: https://ethical-ad-client.readthedocs.io/
*/

import { getConfig } from "./runtimeConfig";

let scriptInjected = false;
let scriptReady = false;
const pendingElements = [];

export function ethicalAdsAvailable() {
  return !!getConfig().ethicalads_id;
}

export function loadEthicalAds() {
  if (!ethicalAdsAvailable()) return;
  if (scriptInjected) return;
  scriptInjected = true;

  const s = document.createElement("script");
  s.async = true;
  s.id = "verihandi-ethicalads";
  s.src = "https://media.ethicalads.io/media/client/ethicalads.min.js";
  s.onload = () => {
    scriptReady = true;
    // Flush any placements that mounted before the client was ready
    while (pendingElements.length) {
      const el = pendingElements.shift();
      tryLoad(el);
    }
  };
  document.head.appendChild(s);
}

function tryLoad(el) {
  try {
    if (window.ethicalads && typeof window.ethicalads.load_placement === "function") {
      window.ethicalads.load_placement(el);
    } else if (window.ethicalads && typeof window.ethicalads.load === "function") {
      // Fallback — rescans whole DOM
      window.ethicalads.load();
    }
  } catch { /* silent — never block UI */ }
}

/* Request the client pick up a newly-mounted placement div. */
export function loadAd(el) {
  if (!el || !ethicalAdsAvailable()) return;
  if (scriptReady) {
    tryLoad(el);
  } else {
    pendingElements.push(el);
    loadEthicalAds();
  }
}
